import React, { useState, useEffect } from "react";
import data from "../data/data";
import { Project } from "./Project";
export const Projects = (props) => {
	const [language, setlanguage] = useState(props.language);
	useEffect(() => {
		setlanguage(props.language);
		// console.log(language);
	}, [props.language]);
	return (
		<div className="Projects" id="projects">
			{/* <CardColumns> */}
			{data.projects.map((project) => {
				return (
					<Project key={project.id} project={project} language={language} />
				);
			})}
			{/* </CardColumns> */}
		</div>
	);
};

export default Projects;



// WEBPACK FOOTER //
// ./src/components/Projects.js